/* CrimeLab — front-end behaviour (vanilla, framework-agnostic) */
(function () {
  'use strict';

  /* ---------- Evergreen countdown (shared target across header + PDP) ---------- */
  function saleTarget(hoursDefault) {
    var KEY = 'cl_sale_end';
    var now = Date.now();
    var stored = parseInt(localStorage.getItem(KEY), 10);
    if (!stored || isNaN(stored) || stored <= now) {
      stored = now + (hoursDefault || 12) * 3600 * 1000;
      try { localStorage.setItem(KEY, String(stored)); } catch (e) {}
    }
    return stored;
  }
  function pad(n) { return String(n).padStart(2, '0'); }
  function initCountdowns() {
    var els = document.querySelectorAll('[data-cl-countdown]');
    if (!els.length) return;
    var hours = parseInt(els[0].getAttribute('data-cl-hours'), 10) || 12;
    var fixed = els[0].getAttribute('data-cl-end');
    var target = fixed ? new Date(fixed).getTime() : saleTarget(hours);
    if (!target || isNaN(target)) target = saleTarget(hours);
    function tick() {
      var d = Math.max(0, Math.floor((target - Date.now()) / 1000));
      var h = Math.floor(d / 3600); d %= 3600;
      var m = Math.floor(d / 60); var s = d % 60;
      var txt = pad(h) + ':' + pad(m) + ':' + pad(s);
      els.forEach(function (el) { el.textContent = txt; });
      if (target - Date.now() <= 0 && !fixed) {
        try { localStorage.removeItem('cl_sale_end'); } catch (e) {}
        target = saleTarget(hours);
      }
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Mobile nav toggle ---------- */
  function initBurger() {
    document.querySelectorAll('[data-cl-burger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var nav = document.getElementById(btn.getAttribute('data-cl-burger'));
        if (nav) {
          var open = nav.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
      });
    });
  }

  /* ---------- Money formatting (uses Shopify format when available) ---------- */
  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney && window.clMoneyFormat) {
      return Shopify.formatMoney(cents, window.clMoneyFormat);
    }
    return 'Rs.' + (cents / 100).toLocaleString('en-US');
  }

  /* ---------- Quantity stepper + live total ---------- */
  function initQty(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-cl-qty-wrap]').forEach(function (wrap) {
      var input = wrap.querySelector('[data-cl-qty]');
      var dec = wrap.querySelector('[data-cl-qty-dec]');
      var inc = wrap.querySelector('[data-cl-qty-inc]');
      if (!input) return;
      function clamp() { var v = parseInt(input.value, 10); if (isNaN(v) || v < 1) v = 1; input.value = v; return v; }
      function updateTotal() {
        var v = clamp();
        var form = wrap.closest('form');
        var totalEl = form && form.querySelector('[data-cl-total]');
        if (totalEl) {
          var unit = parseInt(totalEl.getAttribute('data-cl-unit'), 10) || 0;
          totalEl.textContent = formatMoney(unit * v);
        }
      }
      dec && dec.addEventListener('click', function () { input.value = Math.max(1, clamp() - 1); updateTotal(); });
      inc && inc.addEventListener('click', function () { input.value = clamp() + 1; updateTotal(); });
      input.addEventListener('input', updateTotal);
    });
  }

  /* ---------- Gallery thumbnail switching ---------- */
  function initGallery() {
    document.querySelectorAll('[data-cl-gallery]').forEach(function (gal) {
      var main = gal.querySelector('[data-cl-gallery-main]');
      var mainLabel = gal.querySelector('[data-cl-gallery-label]');
      gal.querySelectorAll('[data-cl-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          gal.querySelectorAll('[data-cl-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          var img = thumb.getAttribute('data-img');
          var label = thumb.getAttribute('data-label');
          if (img && main) {
            main.style.backgroundImage = 'url(' + img + ')';
            main.style.backgroundSize = 'cover';
            main.style.backgroundPosition = 'center';
            if (mainLabel) mainLabel.style.display = 'none';
          } else if (mainLabel) {
            main && (main.style.backgroundImage = '');
            mainLabel.style.display = '';
            if (label) mainLabel.textContent = label;
          }
        });
      });
    });
  }

  /* ---------- Cart count refresh ---------- */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cl-cart-count]').forEach(function (b) {
          b.textContent = cart.item_count;
          b.style.display = cart.item_count > 0 ? '' : 'none';
        });
      }).catch(function () {});
  }

  /* ---------- Add to cart (AJAX) ---------- */
  function initAddToCart() {
    document.querySelectorAll('[data-cl-add-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var checkout = e.submitter && e.submitter.hasAttribute('data-cl-buynow');
        var btn = e.submitter || form.querySelector('[type=submit]');
        var original = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; }
        var data = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            if (btn) { btn.disabled = false; btn.textContent = original; }
            if (checkout) { window.location.href = '/checkout'; return; }
            CartUI.open(); // renders fresh contents + refreshes count
          })
          .catch(function () {
            if (btn) { btn.disabled = false; btn.textContent = original; }
            form.submit(); // fallback to full-page add
          });
      });
    });
  }

  /* ---------- Cart drawer ---------- */
  var CartUI = (function () {
    var drawer, overlay, body, footer, countEl, subEl, shipEl, shipMsg, shipFill;
    function els() {
      drawer = document.querySelector('[data-cl-cart-drawer]');
      overlay = document.querySelector('[data-cl-cart-overlay]');
      body = document.querySelector('[data-cl-cart-body]');
      footer = document.querySelector('[data-cl-cart-footer]');
      countEl = document.querySelector('[data-cl-drawer-count]');
      subEl = document.querySelector('[data-cl-cart-subtotal]');
      shipEl = document.querySelector('[data-cl-ship]');
      shipMsg = document.querySelector('[data-cl-ship-msg]');
      shipFill = document.querySelector('[data-cl-ship-fill]');
    }
    function updateShip(cart) {
      if (!shipEl) return;
      var threshold = parseInt(shipEl.getAttribute('data-threshold'), 10) || 0;
      if (threshold <= 0 || cart.item_count === 0) { shipEl.hidden = true; return; }
      shipEl.hidden = false;
      var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
      if (shipFill) shipFill.style.width = pct + '%';
      if (cart.total_price >= threshold) {
        shipEl.classList.add('is-unlocked');
        if (shipMsg) shipMsg.innerHTML = '🚚 <b>FREE delivery unlocked!</b> Case closed.';
      } else {
        shipEl.classList.remove('is-unlocked');
        if (shipMsg) shipMsg.innerHTML = 'Add <b>' + formatMoney(threshold - cart.total_price) + '</b> more for <b>FREE delivery</b> 🚚';
      }
    }
    function open() {
      els();
      if (!drawer) return;
      overlay.hidden = false; drawer.hidden = false;
      requestAnimationFrame(function () { overlay.classList.add('is-open'); drawer.classList.add('is-open'); });
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      render();
    }
    function close() {
      if (!drawer) return;
      overlay.classList.remove('is-open'); drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(function () { if (overlay) overlay.hidden = true; if (drawer) drawer.hidden = true; }, 300);
    }
    function esc(str) { return (str == null ? '' : String(str)).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function lineRow(item) {
      var img = item.image ? '<img src="' + item.image + '" alt="">' : '<span class="ph">' + esc(item.product_title) + '</span>';
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<div class="cl-line-variant">' + esc(item.variant_title) + '</div>' : '';
      return '<div class="cl-line" data-key="' + item.key + '">'
        + '<div class="cl-line-img">' + img + '</div>'
        + '<div><h4 class="cl-line-name">' + esc(item.product_title) + '</h4>' + variant
        + '<div class="cl-line-qty"><button type="button" data-cl-line-dec aria-label="Decrease">−</button><span>' + item.quantity + '</span><button type="button" data-cl-line-inc aria-label="Increase">+</button></div></div>'
        + '<div class="cl-line-right"><span class="cl-line-price">' + formatMoney(item.final_line_price) + '</span>'
        + '<button type="button" class="cl-line-remove" data-cl-line-remove>Remove</button></div>'
        + '</div>';
    }
    function updateCount(n) {
      if (countEl) countEl.textContent = '(' + n + ')';
      document.querySelectorAll('[data-cl-cart-count]').forEach(function (b) { b.textContent = n; b.style.display = n > 0 ? '' : 'none'; });
    }
    function render() {
      els();
      if (!body) return;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCount(cart.item_count);
          updateShip(cart);
          if (cart.item_count === 0) {
            body.innerHTML = '<div class="cl-drawer-empty"><span class="big">No files yet</span>Your case file is empty. Pick a mystery and start the investigation.</div>';
            if (footer) footer.style.display = 'none';
          } else {
            body.innerHTML = cart.items.map(lineRow).join('');
            if (footer) footer.style.display = '';
            if (subEl) subEl.textContent = formatMoney(cart.total_price);
          }
        }).catch(function () {});
    }
    function change(key, qty) {
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); })
        .then(function () { render(); }).catch(function () {});
    }
    function bind() {
      els();
      if (!drawer) return;
      document.querySelectorAll('[data-cl-cart-open]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); open(); });
      });
      document.querySelectorAll('[data-cl-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
      if (overlay) overlay.addEventListener('click', close);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      body.addEventListener('click', function (e) {
        var row = e.target.closest('[data-key]'); if (!row) return;
        var key = row.getAttribute('data-key');
        var qtyEl = row.querySelector('.cl-line-qty span');
        var q = parseInt(qtyEl.textContent, 10) || 1;
        if (e.target.closest('[data-cl-line-inc]')) change(key, q + 1);
        else if (e.target.closest('[data-cl-line-dec]')) change(key, Math.max(0, q - 1));
        else if (e.target.closest('[data-cl-line-remove]')) change(key, 0);
      });
    }
    return { open: open, close: close, render: render, bind: bind };
  })();

  /* ---------- Video reels carousel ---------- */
  function initReels() {
    document.querySelectorAll('[data-cl-reels]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-cl-reels-track]');
      if (!track) return;
      function step() {
        var card = track.querySelector('.cl-reel-card');
        return card ? card.getBoundingClientRect().width + 18 : 318;
      }
      var prev = wrap.querySelector('[data-cl-reels-prev]');
      var next = wrap.querySelector('[data-cl-reels-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
    // Tap-to-play for self-hosted reel videos
    document.querySelectorAll('[data-cl-reel-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.parentElement.querySelector('video');
        if (!v) return;
        v.setAttribute('controls', '');
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
        btn.style.display = 'none';
        var badge = btn.parentElement.querySelector('.cl-reel-badge');
        if (badge) badge.style.display = 'none';
      });
    });
  }

  /* ---------- Modal (trailer video) ---------- */
  function modalMedia(modal) { return modal.querySelector('video, iframe[data-cl-embed]'); }
  function openModal(modal) {
    if (!modal) return;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var m = modalMedia(modal);
    if (m) {
      if (m.tagName === 'VIDEO') { try { m.currentTime = 0; m.play(); } catch (e) {} }
      else if (m.hasAttribute('data-src')) {
        var src = m.getAttribute('data-src');
        m.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
      }
    }
  }
  function closeModal(modal) {
    if (!modal || modal.hidden) return;
    var m = modalMedia(modal);
    if (m) {
      if (m.tagName === 'VIDEO') { try { m.pause(); } catch (e) {} }
      else { m.src = ''; } // stop iframe playback
    }
    modal.hidden = true;
    document.documentElement.style.overflow = '';
  }
  function initModals() {
    document.querySelectorAll('[data-cl-modal-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { openModal(document.getElementById(btn.getAttribute('data-cl-modal-open'))); });
    });
    document.querySelectorAll('[data-cl-modal-close]').forEach(function (el) {
      el.addEventListener('click', function () { closeModal(el.closest('[data-cl-modal]')); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') document.querySelectorAll('[data-cl-modal]:not([hidden])').forEach(closeModal);
    });
  }

  function init() {
    initCountdowns();
    initBurger();
    initQty(document);
    initGallery();
    initAddToCart();
    CartUI.bind();
    initReels();
    initModals();
    refreshCartCount();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
